<template>
  <div class="backgroud-white cs-courseSchedule-editor">
    <div class="text-center">
      <h4>{{ isAdded?'添加电脑': '编辑电脑'}}</h4>
    </div>
    <div class="backgroud-gray-popup popup-content-area-small">
      <el-form
        ref="model"
        :rules="rules"
        :model="model"
        label-width="100px"
      >
        <el-form-item
          label="电脑名称"
          prop="computerName"
        >
          <el-input
            @change='checkAllInputs'
            placeholder="请输入电脑名称"
            v-model="model.computerName"
            class="input-width"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="!isAdded"
          label="状态"
        >
          <el-select
            v-model="model.isActive"
            placeholder="请选择状态"
          >
            <el-option
              key="0"
              label="可用"
              :value="true"
            ></el-option>
            <el-option
              key="1"
              label="不可用"
              :value="false"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="不可用时间段">
          <label>请添加不可用时间段，在不可用时间段范围内，<span class="cs-import-message">不能预约视频</span></label>
        </el-form-item>
        <el-row v-for="(schedule,index) in model.schedules" :key="index">
          <computerUnavailableTimeScheduleTimePicker :rowIndex="index" :isSameAsAbove="model.isSameAsAbove" :currentSchedulesAll="model.schedules" :scheduleForm="schedule" v-on:deleteRow="onDeleteRow" v-on:editRow="onEditingRow" ref="computerUnavailableTimeScheduleTimePicker">
          </computerUnavailableTimeScheduleTimePicker>
        </el-row>
        <el-row>
          <el-col style="width:20px">&nbsp;</el-col>
          <el-col class="timepicker-col">
            <el-button type="text" @click="addRow()"><i class="el-icon el-icon-plus"></i>添加</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div
      slot="footer"
      class="dialog-footer popup-footer"
    >
      <el-row>
        <el-col
          :span="20"
          class="footer-left"
        >
          <span v-if="!showError"></span>
          <el-alert
            :closable="false"
            v-if="showError"
            v-bind:title="errorMessage"
            type="error"
            show-icon
          ></el-alert>
        </el-col>
        <el-col
          class="footer-right"
          :span="4"
        >
          <el-button
            :disabled="submitBtnDisable"
            :type="submitBtnClass"
            @click="save()"
          >{{ isAdded?'确认添加': '保存更新'}}</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style>
.cs-import-message{
  font-weight: bold;
  color:red;
}
</style>

<script>
import computerUnavailableTimeScheduleTimePicker from "@/components/computerUnavailableTimeScheduleTimePicker";

import { guid, formatTimeToInt60 } from "@/config/mUtils";
import { saveComputer } from "@/service/common.service";

export default {
  props: {
    data: {},
    currentCampusId: ""
  },
  data() {
    return {
      model: {
        id: "",
        computerName: "",
        isActive: false,
        schedules: [],
        removeIdList: [],
        editingRowId:'',
        isSameAsAbove: true
      },
      submitBtnClass: "primay",
      submitBtnDisable: false,
      isAdded: false,
      showError: false,
      errorMessage: "",
      rules: {
        computerName: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur"
          },
          {
            min: 0,
            max: 20,
            message: "最大长度在为20个字符",
            trigger: "blur"
          }
        ]
      }
    };
  },
  components: {
    computerUnavailableTimeScheduleTimePicker
  },
  created() {
    this.loadData();
  },
  methods: {
    checkAllInputs() {
      let isValid = true;

      if (!this.$refs["model"]) return false;

      this.$refs["model"].validate(valid => {
        if (!valid) {
          isValid = false;
          return;
        }
      });

      return isValid;
    },
    save() {
      let isValid = this.checkAllInputs();
      if (!isValid)
        return false;

      if (!!this.$refs.computerUnavailableTimeScheduleTimePicker) {
        for (let i = 0; i < this.$refs.computerUnavailableTimeScheduleTimePicker.length; i++) {
          let index = this.$refs.computerUnavailableTimeScheduleTimePicker.length - 1 - i;
          isValid = isValid && this.$refs.computerUnavailableTimeScheduleTimePicker[index].validateRow();
        }
        if (!isValid)
          return false;
      }

      this.submitBtnDisable = true;
      let result = saveComputer(
        this.model.id,
        this.model.computerName,
        this.model.isActive,
        this.currentCampusId,
        this.model.schedules,
        this.model.removeIdList
      ).then(result => {
        if (!result.success) {
          this.errorMessage = result.message;
          this.showError = true;
        } else {
          this.$message({
            message: "保存成功",
            type: "success"
          });
          this.showError = false;
          this.$emit("saveSuccess", this.isAdded, result.data);
        }
        this.submitBtnDisable = false;
      });
    },
    resetFields() {
      this.$refs["model"].resetFields();
      this.loadData();
    },
    loadData() {
      if (!!this.data && !!this.data.Id) {
        this.isAdded = false;
        this.model.id = this.data.Id;
        this.model.computerName = this.data.ComputerName;
        this.model.isActive = this.data.IsActive;
        this.model.schedules = [];
        if (!!this.data.ComputerUnavailableTimeSchedules) {
          let self = this;
          this.data.ComputerUnavailableTimeSchedules.forEach(function(item, index) {
            let dateRange = [
              new Date(item.StartDateText),
              new Date(item.EndDateText)
            ];
            let startTime = formatTimeToInt60(item.StartTimeText);
            let endTime = formatTimeToInt60(item.EndTimeText, true);
            self.model.schedules.push({
              id: guid(),
              dataId: item.Id,
              dateRange: dateRange,
              startTime: startTime,
              endTime: endTime
            });
          });
        }
        this.submitBtnClass = "primary";
        this.submitBtnDisable = false;
      } else {
        this.isAdded = true;
        this.model.id = "";
        this.model.computerName = "";
        this.model.isActive = true;
        this.model.schedules = [];
        this.submitBtnClass = "primary";
        this.submitBtnDisable = false;
      }
    },
    checkAllTimeIsSame() {
      this.$data.model.isSameAsAbove = true;
      if (this.$data.model.schedules) {
        let self = this;
        this.$data.model.schedules.forEach((item, i) => {
          if (i > 0 && item.id !== self.$data.model.editingRowId && item.startTime !== '' && item.endTime !== '') {
            if (item.endTime !== self.$data.model.schedules[i - 1].endTime ||
              item.startTime !== self.$data.model.schedules[i - 1].startTime) {
              self.$data.model.isSameAsAbove = false; 
            }
          }
          if(i > 0 && item.id === self.$data.model.editingRowId){ 
            if (self.__equalDateRange(item.dateRange, self.$data.model.schedules[i - 1].dateRange)) {
              self.$data.model.isSameAsAbove = false;
            }
          }
        });
      }
    },
    addRow() {
      if (!!this.$refs.computerUnavailableTimeScheduleTimePicker) {
        let valid = true;
        for (let i = 0; i < this.$refs.computerUnavailableTimeScheduleTimePicker.length; i++) {
          let index = this.$refs.computerUnavailableTimeScheduleTimePicker.length - 1 - i;
          valid =
            valid && this.$refs.computerUnavailableTimeScheduleTimePicker[index].validateRow();
        }
        if (!valid)
          return;
      }

      let newRow = {
        id: guid(),
        dataId: 0,
        dateRange: [],
        startTime: "",
        endTime: ""
      };
      this.$data.model.schedules.push(newRow);
    },
    onDeleteRow(currentRowId) {
      this.$data.model.schedules.forEach((item, i) => {
        if (item.id === currentRowId) {
          if (item.dataId && this.model.removeIdList.indexOf(item.dataId) < 0) {
            this.model.removeIdList.push(item.dataId);
          }
          this.$data.model.schedules.splice(i, 1);
        }
      });
      this.checkAllTimeIsSame();
    },
    onEditingRow(id){ 
      this.$data.model.editingRowId = id;
      this.checkAllTimeIsSame() ;
    },
    __equalDateRange(dateRange1, dateRange2) {
      if (dateRange1.length != dateRange2.length)
        return false;
      
      if (moment(dateRange1[0]).format('YYYY/MM/DD') != moment(dateRange2[0]).format('YYYY/MM/DD'))
        return false;
      
      if (moment(dateRange1[1]).format('YYYY/MM/DD') != moment(dateRange2[1]).format('YYYY/MM/DD'))
        return false;
      
      return true;
    }
  },
  watch: {
    data: function() {
      this.loadData();
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/computerEditor.vue